/**
 * required to exclude the optional jQuery dependency of `bootstrap-slider` (used by
 * `react-bootstrap-slider`).  This approach is suggested by the `bootstrap-slider` documentation
 * here https://github.com/seiyria/bootstrap-slider#how-do-i-exclude-the-optional-jquery-dependency-from-my-build
 */
module.exports = null;
